module.exports = __webpack_public_path__ + "assets/images/pages/ebaysocial/icon-ebaysocial-2.png?f4193453";